import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/tuyen-dung/yeu-cau-tuyen-dung'

// Lọc danh sách yêu cầu tuyển dụng
export function locYeuCauTuyenDung(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết yêu cầu tuyển dụng
export function layChiTietYeuCauTuyenDung(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo yêu cầu tuyển dụng
export function taoYeuCauTuyenDung(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật yêu cầu tuyển dụng
export function capNhatYeuCauTuyenDung(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa yêu cầu tuyển dụng
export function xoaYeuCauTuyenDung(id: number) {
  try {
    return axiosApi.delete(`${BASE}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Phê duyệt yêu cầu tuyển dụng
export function duyetYeuCauTuyenDung(id: number, params?: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/duyet`, params || {})
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Từ chối yêu cầu tuyển dụng
export function tuChoiYeuCauTuyenDung(id: number, params?: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/tu-choi`, params || {})
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Kiểm tra ngân sách
export function kiemTraNganSach(recruitmentRequestId: number) {
  try {
    return axiosApi.get(`${BASE}/${recruitmentRequestId}/kiem-tra-ngan-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
